export default __webpack_public_path__ + "ac4f0f0ea73b574024a69b2e969469f8.png";